import axios from "axios";
import React, { createContext, useContext, useState } from "react";
import { useAuth0Context } from "./Auth0Context";
import { BASE_URL } from "../constant/constant";
import { toastError, toastSuccess } from "../utils/toastUtils";
import authService from "../services/authService";

const AxiosContextApi = createContext();
const useAxiosContext = () => useContext(AxiosContextApi);

const AxiosContext = ({ children }) => {
  const [applicationId, setApplicationId] = useState("");
  const { token } = useAuth0Context();
  // console.log(token);
  const axiosInstance = axios.create({
    baseURL: BASE_URL + "/api/v1",
    timeout: 20000,
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
      "Zino-App-Id": applicationId || window.location.pathname.split("/")?.[4] || ""
    }
  });

  // axiosInstance.interceptors.request.use((config) => {
  //   const abortController = new AbortController();
  //   config.signal = abortController.signal;
  //   config.abortController = abortController;
  //   return config;
  // });

  axiosInstance.interceptors.response.use(
    (response) => {
      if (response.data) {
        // response.data.config = response.config;
        return response.data;
      }
      return response;
    },
    (error) => {
      throw error;
    }
  );

  const handleError = (error) => {
    console.log(error);
    if (error?.response?.data?.code === 401) {
      authService.removeToken();
      window.open("/", "_self");
    }
    if (error?.name !== "CanceledError") {
      let message = "";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (typeof error === "string") {
        message = error;
      } else {
        message = "Something went wrong";
      }
      toastError(message);
    }
  };

  const handleSuccess = (message) => {
    toastSuccess(message);
  };

  return (
    <AxiosContextApi.Provider
      value={{
        applicationId,
        axiosInstance,
        handleError,
        handleSuccess,
        setApplicationId
      }}
    >
      {children}
    </AxiosContextApi.Provider>
  );
};

export default AxiosContext;
export { useAxiosContext };
